import React from "react";
import './PersonalPage.css';
import '../../Elements/Buttons/ButtonStandart/ButtonStandart.css';
import TopPafeInfo from "../../Elements/BigElements/TopPageInfo/TopPafeInfo";
import PersonalPage01 from "../../../img/PersonalPage/PersonalPage01.svg";
import PersonalPage02 from "../../../img/PersonalPage/ethereum.png";
import bsclogo from "../../../img/PersonalPage/bsc.png";
import hash from "../../../img/PersonalPage/hash.png";
import PersonalPage05 from "../../../img/PersonalPage/PersonalPage05.svg";
import PersonalPage06 from "../../../img/PersonalPage/PersonalPage06.svg";
import PersonalPage07 from "../../../img/PersonalPage/telegram_icon.svg";
import ButtonStandart from "../../Elements/Buttons/ButtonStandart/ButtonStandart";
import {withAuth} from "../../withAuth";
import {withRouter} from "react-router-dom";
import {UPDATE_USER} from "../../../queries";
import {GET_ONE_CLIENT} from "../../../queries";
import {Mutation} from "react-apollo";
import Query from "react-apollo/Query";
import '../../Elements/Buttons/ButtonRed/ButtonRed.css';
import ButtonWhite from "../../Elements/Buttons/ButtonWhite/ButtonWhite";
import ButtonGreen from "../../Elements/Buttons/ButtonGreen/ButtonGreen";
import { personalLang } from "./personalLang";

class PersonalPage extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            Agent: this.props.session.Agent,
            email: this.props.session.email,
            NicName: this.props.session.NicName,
            Name: this.props.session.Name,
            Surname:  this.props.session.Surname,
            Birthday: this.props.session.Birthday,
            PostalCode:   this.props.session.PostalCode,
            City:  this.props.session.City,
            Address:  this.props.session.Address,
            MobilePhone:  this.props.session.MobilePhone,
            Skype:  this.props.session.Skype,
            Balance:  this.props.session.Balance,
            AllText: this.props.AllText,
            ETHWallet: this.props.session.ETHWallet,
            IsWithdrawal: this.props.session.IsWithdrawal,
            ETHWalletInfo: false,
            BSCWallet: this.props.session.BSCWallet,
            IsBSCWithdrawal: this.props.session.IsBSCWithdrawal,
            HashTag: this.props.session.HashTag,
            BSCWalletInfo: false,
            GlobalBlack: "StandartUnVisible",
            successButton: false,
            Language : localStorage.getItem('language') ? localStorage.getItem('language') : 'en',
        };
        this.GlobalBlack = this.GlobalBlack.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    
    ChangeElement = event => {
        const {name, value} = event.target;
        this.setState({[name] : value});
        //console.log(this.state);      
    };

    handleCheck = event => {
        if (!this.state.ETHWallet) {
            this.setState({ETHWalletInfo: true});
        } else {
            this.setState({IsWithdrawal: !this.state.IsWithdrawal, ETHWalletInfo: false});
        }
    };

    handleCheck2 = event => {
        if (!this.state.BSCWallet) {
            this.setState({BSCWalletInfo: true});
        } else {
            this.setState({IsBSCWithdrawal: !this.state.IsBSCWithdrawal, BSCWalletInfo: false});
        }
    };

    ChangeElementNicName = event => {
        event.preventDefault();
        const { name, value } = event.target;
        //console.log(value);
        let regex = /\W+/g;
        let newvalue = value.replace(regex, '');
        if (newvalue == '') { 
            this.setState({ NicName: '' });
        } else {
            this.setState({ NicName: newvalue.replace(/\s+/g, '').toLowerCase() });    
        }
        //console.log(newvalue);
        //if ( (event.keyCode > 64 && event.keyCode < 91) || (event.keyCode > 96 && event.keyCode < 123) || event.keyCode == 8 || event.keyCode == 32 || (event.keyCode >= 48 && event.keyCode <= 57) ) {
            
        //}        
    }

    ChangeElementNicNameKey = event => {
        event.preventDefault();
        const { name, value } = event.target;
        let regex = /\W+/g;
        let newvalue = value.replace(regex, '');
        if ( (event.keyCode > 64 && event.keyCode < 91) || (event.keyCode > 96 && event.keyCode < 123) || event.keyCode == 8 || event.keyCode == 32 || (event.keyCode >= 48 && event.keyCode <= 57) ) {
            this.setState({ NicName: newvalue.replace(/\s+/g, '').toLowerCase() }); 
        }  
        //console.log(this.state.NicName);
    }

    checkNicName() {
        let NicName = this.props.session.NicName ? this.props.session.NicName : '';
        if (typeof this.props.session.NicName == "undefined" && !this.props.session.NicName) {
            NicName = '';
        }
        return NicName.length > 0 ? true : false;
    }
       
    GlobalBlack(e) {
        e.preventDefault();
        this.setState({ GlobalBlack: "StandartUnVisible" });
    };
   
    UserUpdate = (event, updateUser) => {
      event.preventDefault();
    //   updateUser().then(({data}) => {
    //       this.setState({NicName: data.updateUser.NicName, Name : data.updateUser.Name, Surname : data.updateUser.Surname, Birthday: data.updateUser.Birthday, PostalCode : data.updateUser.PostalCode,City : data.updateUser.City,
    //       Address : data.updateUser.Address,MobilePhone : data.updateUser.MobilePhone,Skype : data.updateUser.Skype, successButton: true});
    //       setTimeout(() => window.open(`https://launch.artyfact.game/personal`, '_top'), 500);
    //   })
    };     

    handleKeyPress = (event) => {
        event.preventDefault();
        console.log('event.key', event.key);
        console.log('event.keyCode', event.keyCode);
        if (event.key === "Escape" || event.key === "Esc" || event.keyCode === 27) {
            this.GlobalBlack(event);
        }
    }

    render(){
        return (
            <div className="PersonalPage">
                <div className={"StandartAllBlack " + this.state.GlobalBlack} onClick={this.GlobalBlack}/>
                
                <TopPafeInfo session={this.props.session} />
                <div className="PersonalPageMain StandartPartMain">
                    <div className="PersonalPageMainPersonalInformation StandartBigElement">
                        <div className="IndexMainElementIn">
                            <div className="StandartElementTitle">{personalLang.title[this.state.Language]}</div>
                            <div className="StandartElementTopBorder"/>
                        </div>
                        <div className="PersonalPageMainPersonalInformationGrid">
                            <form onSubmit={this.handleSubmit}  className="PersonalPageMainPersonalInformationGridForm">
                                <div  className="PersonalPageInput">
                                    <img src={PersonalPage01}/>
                                    <label>
                                        <input type="text" value={this.state.Name ? this.state.Name : ''} disabled name="Name" onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                        <span className="TextPlaceHolder">{personalLang.name[this.state.Language]}<sup>*</sup></span>
                                        <span className="border"/>
                                    </label>
                                </div>
                                <div  className="PersonalPageInput">
                                    <img src={PersonalPage01}/>
                                    <label>
                                        <input type="text" value={this.state.Surname ? this.state.Surname : ''} disabled name="Surname"  onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                        <span className="TextPlaceHolder">{personalLang.surname[this.state.Language]}<sup>*</sup></span>
                                        <span className="border"/>
                                    </label>
                                </div>
                                <div className="PersonalPageInput">
                                    <img src={PersonalPage01}/>
                                    <label>
                                        <input type="date" value={this.state.Birthday ? this.state.Birthday : ''} disabled name="Birthday"  onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                        <span className="TextPlaceHolder">{personalLang.birth[this.state.Language]}</span>
                                        <span className="border"/>
                                    </label>
                                </div>   
                                     
                                    <div className="PersonalPageInput">
                                        <img src={PersonalPage01} />
                                        <label> {/* disabled={this.checkNicName()} */}
                                            <input type="text" value={this.state.NicName ? this.state.NicName : null} disabled name="NicName" onChange={event => this.ChangeElementNicName(event)} onKeyUp={event => this.ChangeElementNicNameKey(event)} placeholder="&nbsp;" />
                                            <span className="TextPlaceHolder">{personalLang.nickname[this.state.Language]}<sup>*</sup></span>
                                            <span className="border" />
                                        </label>
                                    </div>                                     
                                
                                
                                 
                                    {/*
                                    <div className="PersonalPageInput">
                                        <img src={PersonalPage05}/>
                                        <label>
                                            <input type="text" value={this.state.MobilePhone ? this.state.MobilePhone : ''} name="MobilePhone"  onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                            <span className="TextPlaceHolder">{personalLang.phone[this.state.Language]}</span>
                                            <span className="border"/>
                                        </label>
                                    </div>
                                    */}
                                    <div  className="PersonalPageInput">
                                        <img src={PersonalPage06}/>
                                        <label>
                                            <input type="text" disabled value={this.state.email ? this.state.email : ''} name="email2"  onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                            <span className="TextPlaceHolder">{this.state.AllText['UpdateUser08']}<sup>*</sup></span>
                                            <span className="border"/>
                                        </label>
                                    </div>
                                    <div  className="PersonalPageInput">
                                        <img src={PersonalPage07}/>
                                        <label>
                                            <input type="text" value={this.state.Skype ? this.state.Skype : ''} name="Skype" disabled onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                            <span className="TextPlaceHolder">Telegram @</span>
                                            <span className="border"/>
                                        </label>
                                    </div>

                                    {/*<div class="row" style={{'width': '100%'}}>
                                        <div class="col-md-4">
                                            <div className="PersonalPageInput" style={{'width': '100%', 'grid-template-columns': '18px 90%'}}>
                                                <img width="23px" src={PersonalPage02}/>
                                                <label>
                                                    { this.props.session.IsWithdrawal ? (
                                                        <input type="text" value={this.state.ETHWallet ? this.state.ETHWallet : ''} name="ETHWallet" placeholder="&nbsp;" disabled />
                                                    ) : (
                                                        <input type="text" value={this.state.ETHWallet ? this.state.ETHWallet : ''} name="ETHWallet" onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                                    )}
                                                    <span className="TextPlaceHolder">ETH wallet (ERC20)</span>
                                                    <span className="border"/>
                                                </label>
                                            </div>
                                            { this.state.ETHWalletInfo && 
                                                <p>Please fill your ETH wallet (ERC20)!</p>
                                            }
                                        </div>
                                        <div class="col-md-4">
                                            <div class="wallet-info">
                                                <label style={{'z-index': '33','position': 'relative'}}>
                                                    { this.props.session.IsWithdrawal ? (
                                                        <input style={{'display': 'block'}} type="checkbox" defaultChecked={this.state.IsWithdrawal} disabled />
                                                    ) : (
                                                        <input style={{'display': 'block'}} type="checkbox" onChange={this.handleCheck} defaultChecked={this.state.IsWithdrawal} />
                                                    )}
                                                </label>
                                                <p>
                                                    By clicking the checkbox, you confirm the correctness of the entered data.<br/>
                                                    <b>Steaking</b> is available for you and you can buy tokens on the website.<br/>
                                                    In case of incorrect entries or questions please contact the <b><u>staking@arno-token.com</u></b> or via the <b>«Support form»</b> on the website.
                                                </p>
                                            </div>

                                        </div>
                                    </div>*/}

                                    <div class="row" style={{'width': '100%'}}>
                                        <div class="col-md-8 col-sm-12">
                                            <div className="PersonalPageInput" style={{'width': '100%', 'grid-template-columns': '18px 94%'}}>
                                                <img width="28px" src={bsclogo}/>
                                                <label>
                                                    { this.props.session.IsBSCWithdrawal ? (
                                                        <input type="text" value={this.state.BSCWallet ? this.state.BSCWallet : ''} name="BSCWallet" disabled placeholder="&nbsp;" onChange={this.ChangeElement} />
                                                    ) : (
                                                        <input type="text" value={this.state.BSCWallet ? this.state.BSCWallet : ''} name="BSCWallet" disabled onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                                    )}
                                                    <span className="TextPlaceHolder">BSC wallet (BEP20)<sup>*</sup></span>
                                                    <span className="border"/>
                                                </label>
                                            </div>
                                            { this.state.BSCWalletInfo && 
                                                <p>{personalLang.fill_wallet[this.state.Language]}</p>
                                            }
                                        </div>
                                    </div>
                                    <div class="row" style={{'width': '100%'}}>
                                        <div class="col-md-8 col-sm-12">
                                            <div class="wallet-info">
                                                <label style={{'z-index': '33','position': 'relative'}}>
                                                    { this.props.session.IsBSCWithdrawal ? (
                                                        <input style={{'display': 'block'}} type="checkbox" defaultChecked={this.state.IsBSCWithdrawal} disabled />
                                                    ) : (
                                                        <input style={{'display': 'block'}} type="checkbox" onChange={this.handleCheck2} defaultChecked={this.state.IsBSCWithdrawal} />
                                                    )}
                                                </label>
                                                <p>
                                                    {personalLang.info[this.state.Language]}<br/>
                                                    {personalLang.info2[this.state.Language]} <a style={{color: '#FCFCFD'}} href="mailto:support@artyfact.game" target="_blank"><b><u>support@artyfact.game</u></b></a> {personalLang.info3[this.state.Language]} <a style={{color: '#FCFCFD'}} href="https://t.me/artyfactsupport" target="_blank"><b>t.me/artyfactsupport</b></a>.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    {/*                    
                                    <div class="row" style={{'width': '100%'}}>
                                        <div class="col-md-8">
                                            <div className="PersonalPageInput" style={{'width': '100%', 'grid-template-columns': '18px 90%'}}>
                                                <img width="28px" src={hash}/>
                                                <label>
                                                    <input type="text" value={this.state.HashTag ? this.state.HashTag : ''} name="HashTag" onChange={this.ChangeElement} placeholder="&nbsp;"/>
                                                    <span className="TextPlaceHolder">Hash Tag</span>
                                                    <span className="border"/>
                                                </label>
                                            </div>
                                        </div>                                        
                                    </div>
                                    */}                    
                            </form>
                            {/*
                            <div className="dflex">                                

                                <Query query={GET_ONE_CLIENT} variables={{ email: this.props.session.Agent ? this.props.session.Agent : ''}}>
                                    {({data, loading, error}) => {                                
                                        if (loading) return <div>loading</div>;
                                        if (error) return <div>error</div>;
                                        if (data.getOneClient) {
                                            let fullname = '';
                                            if (data.getOneClient.Name && data.getOneClient.Surname) {
                                                fullname = data.getOneClient.Name + ' ' + data.getOneClient.Surname;
                                            }

                                            return (
                                                <div className="dflex">
                                                    <div className="PersonalPageInput MentorPadd">
                                                        <img src={PersonalPage01} />
                                                        <label>
                                                            <input type="text" disabled="disabled" value={fullname ? fullname : ''} placeholder="&nbsp;" />
                                                            <span className="TextPlaceHolder">Mentor's Name</span>
                                                            <span className="border" />
                                                        </label>
                                                    </div>
                                                    <div className="PersonalPageInput">
                                                        <img src={PersonalPage01}/>
                                                        <label>
                                                            <input type="text" disabled="disabled" value={this.state.Agent ? this.state.Agent : ''} name="Agent" placeholder="&nbsp;"/>
                                                            <span className="TextPlaceHolder">Mentor's Email</span>
                                                            <span className="border"/>
                                                        </label>
                                                    </div>
                                                    <div className="PersonalPageInput">
                                                        <img src={PersonalPage01} />
                                                        <label>
                                                            <input type="text" disabled="disabled" value={data.getOneClient.MobilePhone ? data.getOneClient.MobilePhone : ''} placeholder="&nbsp;" />
                                                            <span className="TextPlaceHolder">Mentor's Phone</span>
                                                            <span className="border" />
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        } else {
                                            return (
                                                <div className="dflex">
                                                    <div className="PersonalPageInput MentorPadd">
                                                        <img src={PersonalPage01} />
                                                        <label>
                                                            <input type="text" disabled="disabled" value="" placeholder="&nbsp;" />
                                                            <span className="TextPlaceHolder">Mentor Name</span>
                                                            <span className="border" />
                                                        </label>
                                                    </div>
                                                    <div className="PersonalPageInput">
                                                        <img src={PersonalPage01}/>
                                                        <label>
                                                            <input type="text" disabled="disabled" value={this.state.Agent ? this.state.Agent : ''} name="Agent" placeholder="&nbsp;"/>
                                                            <span className="TextPlaceHolder">Mentor Email</span>
                                                            <span className="border"/>
                                                        </label>
                                                    </div>
                                                    <div className="PersonalPageInput">
                                                        <img src={PersonalPage01} />
                                                        <label>
                                                            <input type="text" disabled="disabled" value="" placeholder="&nbsp;" />
                                                            <span className="TextPlaceHolder">Mentor Phone</span>
                                                            <span className="border" />
                                                        </label>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        
                                    }}
                                </Query>         
                            </div>
                            */}

                            <div  className="PersonalPageMainPersonalInformationGridBottom">

                                <Mutation mutation={UPDATE_USER} variables={{email: this.state.email, NicName: this.state.NicName, Name:this.state.Name, Surname:this.state.Surname, Birthday: this.state.Birthday,
                                    PostalCode: this.state.PostalCode, City:this.state.City, Address:this.state.Address, MobilePhone:this.state.MobilePhone, Skype:this.state.Skype, ETHWallet: this.state.ETHWallet, BSCWallet: this.state.BSCWallet, IsWithdrawal: this.state.IsWithdrawal, IsBSCWithdrawal: this.state.IsBSCWithdrawal, HashTag: this.state.HashTag }}>
                                    {(updateUser,{data, loading, error}) => {
                                        return(
                                            <>
                                            {this.state.successButton ? (
                                                <div className="successButton">{personalLang.success[this.state.Language]}</div>
                                              ) : (
                                                <div onClick={event => this.UserUpdate(event, updateUser)} >
                                                    <ButtonStandart ssilka='#' classname='ButtonStandart' label={personalLang.save[this.state.Language]} />
                                                    {error && <p style={{ color: '#ff0404'}}>{error.message}</p>}
                                                </div>
                                            )}                                            
                                            </>
                                        )
                                    }}

                                </Mutation>

                            </div>
                        </div>
                    </div>
                   
                </div>
            </div>
        )}}

export default withAuth(session => session && session)(withRouter(PersonalPage));